<template>
  <div class="outer-wrap">
    <Sidebar
      v-if="this.getStructureDetails"
      :show="showSidebar"
      :adminRights="userHasAdminRight"
      :sensors="this.getStructureDetails.sensors"
      @sidebartoggle="showSidebar = !showSidebar"
      @settingstoggle="
        showSettings = !showSettings;
        showMonitor = false;
        showSidebar = false;
        showAnalogNode = false;
      "
      @monitortoggle="
        showMonitor = !showMonitor;
        showSettings = false;
        showSidebar = false;
        showAnalogNode = false;
      "
      @analog-node-toggle="
        showAnalogNode = !showAnalogNode;
        showMonitor = false;
        showSettings = false;
        showSidebar = false;
      "
    />
    <!-- Navigation Bar -->
    <div id="navbar">
      <NavBar v-show="true" @logout="this.logout" @sidebartoggle="showSidebar = !showSidebar" />
      <div id="general-info">
        <!-- Selezione Struttura -->
        <BridgeOverview
          id="bridge-ow"
          :bridges="this.getStructures"
          :selectedBridge="this.getStructureDetails"
          v-if="this.loaded && this.getStructureDetails"
          @struct-selected="selectStructure"
        />
      </div>
    </div>
    <!-- Modal Impostazioni -->
    <div class="event-details" id="page-wrap">
      <!-- Settings -->
      <transition name="settings">
        <Settings id="set" v-if="showSettings" :selectedStructure="this.getStructureDetails" @settingstoggle="showSettings = !showSettings" />
      </transition>
      <!-- Monitor -->
      <transition name="settings">
        <Monitor id="monitor" v-if="showMonitor" :selectedStructure="this.getStructureDetails" @monitortoggle="showMonitor = !showMonitor" />
      </transition>
      <!-- Analog Node -->
      <transition name="settings">
        <AnalogNode
          id="analog-node"
          v-if="this.getStructureDetails && showAnalogNode && userHasAdminRight"
          :selectedStructure="this.getStructureDetails"
          @close-me="showAnalogNode = false"
          @need-refresh="this.fetchStructureData"
        />
      </transition>
      <!-- Loading -->
      <transition name="load">
        <LoadingLogo v-if="!this.loaded || !this.getLoadingStatus" />
      </transition>
      <!-- Controllo Eventi -->
      <eventsControl id="bridge-ow" :structureDetails="this.getStructureDetails" v-if="this.loaded && this.getStructureDetails" />
      <!-- Wrapper Esterno Eventi -->
      <div class="outer-event">
        <div class="inner-event">
          <!-- Grafici Eventi -->
          <eventDetails v-if="this.loaded && this.getStructureDetails" />
          <!-- Grafico FFT -->
          <displacementFFT v-if="this.loaded && this.getSelectedSensor && this.getSelectedSensor.type === 'deck'" />
          <accelerationsFFT v-if="this.loaded && this.getSelectedSensor && this.getSelectedSensor.type === 'accelerometer'" />
        </div>
        <!-- Selezione Evento -->
        <section v-if="this.getSelectedSensor && (this.getSelectedSensor.type === 'deck' || this.getSelectedSensor.type === 'accelerometer')">
          <eventList id="list" v-if="this.loaded && this.getStructureDetails" />
        </section>
      </div>
      <!-- Grafico Temperature -->
      <Temperatures v-if="this.loaded && this.getStructureDetails && this.getSelectedSensor && this.getSelectedSensor.type != 'analog-node'" />
      <Footer />
    </div>
  </div>
</template>
<script>
import displacementFFT from "../components/modules/events/vibrationsFFT.vue";
import accelerationsFFT from "../components/modules/events/accelerationsFFT.vue";
import eventsControl from "../components/modules/events/eventsControl.vue";
import NavBar from "../components/ui/NavigationBar.vue";
import BridgeOverview from "../components/ui/BridgeOverview.vue";
import eventList from "../components/modules/events/eventList.vue";
import Temperatures from "../components/modules/events/temperatures.vue";
import eventDetails from "../components/modules/events/eventDetails.vue";
import LoadingLogo from "../components/ui/LoadingLogo";
import Sidebar from "../components/ui/Sidebar.vue";
import Settings from "./Settings";
import AnalogNode from "../views/AnalogNode";
import Monitor from "./Monitor";
import Footer from "../components/ui/Footer";
import $ from "jquery";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "event-details",
  components: {
    NavBar,
    eventsControl,
    Temperatures,
    eventDetails,
    displacementFFT,
    accelerationsFFT,
    BridgeOverview,
    LoadingLogo,
    Sidebar,
    Footer,
    Settings,
    AnalogNode,
    Monitor,
    eventList,
  },
  // Props per forzare la selezione da route precedente
  props: {
    selectedSensorID: String,
    selectedStructureID: String,
  },
  data() {
    return {
      loaded: false,
      showSidebar: false,
      showSettings: false,
      showMonitor: false,
      showAnalogNode: false,
    };
  },
  methods: {
    ...mapActions({
      fetchStructures: "structure/fetchStructures",
      fetchStructureData: "structure/fetchStructureData",
      selectStructure: "structure/selectStructure",
      setSelectedSensor: "eventdetails/setSelectedSensor",
      logout: "auth/logout",
      fetchDispDetails: "eventdetails/fetchDispDetails",
      fetchUserSettings: "user/fetchUserSettings",
    }),
    logoutSession: function () {
      this.logout();
    },
    setupNavigationSticky: function () {
      // Setta l'hiding automatico della Navigation Bar
      var prevScrollpos = window.pageYOffset;
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos - currentScrollPos > 0) {
          $("#navbar").css("-webkit-transform", "translateY(0px");
          $("#navbar").css("transform", "translateY(0px");
        } else {
          if (currentScrollPos > 50) {
            $("#navbar").css("-webkit-transform", "translateY(-150px");
            $("#navbar").css("transform", "translateY(-150px");
          }
        }
        prevScrollpos = currentScrollPos;
      };
    },
  },
  computed: {
    ...mapGetters({
      getStructures: "structure/getStructures",
      getSensors: "structure/getSensors",
      getSelectedStructure: "structure/getSelectedStructure",
      getStructureDetails: "structure/getStructureDetails",
      getSelectedSensor: "eventdetails/getSelectedSensor",
      getLoadingStatus: "eventdetails/getLoadingStatus",
    }),
    userHasAdminRight() {
      return !this.getUserType || this.getUserType === "standard";
    },
    isLambro() {
      return this.getSensors ? this.getSensors.some((sn) => sn.eui === "C0EE400001015144") : false;
    },
  },
  watch: {
    getSelectedStructure: {
      // Chiamata quando chiama la struttura selezionata
      handler: async function (newValue) {
        if (newValue) {
          this.loaded = false;
          await this.fetchStructureData();
          this.loaded = true;
        }
      },
      deep: true,
    },
    getStructureDetails: {
      // Aggiorna le info sul sensore attualmente selezionato
      handler: async function (newValue, oldValue) {
        if (oldValue && this.getSelectedSensor) {
          let euiSelected = this.getSelectedSensor.eui;
          let newItem = newValue.sensors.find((x) => x.eui === euiSelected);
          this.setSelectedSensor(newItem);
          this.loaded = true;
        }
      },
      deep: true,
    },
  },
  async mounted() {
    // Viene effettuato il fetch delle strutture
    await this.fetchStructures();
    await this.fetchUserSettings();
    if (!this.getSelectedStructure) {
      await this.selectStructure(this.getStructures[0]);
    }
    await this.setupNavigationSticky();
    /* console.log("Struttura selezionata da Router", this.selectedStructureID);
    console.log("Sensore selezionato da Router", this.selectedSensorID); */
    //await this.setupNavigationSticky();
  },
};
</script>
<style scoped>
* {
  font-size: 1em;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
}
/* NavBar */
#navbar {
  transition: transform 0.3s;
  position: fixed;
  width: 100%;
  min-width: 840px;
  z-index: 999999;
}
#general-info {
  height: 60px;
  background-color: transparent;
  width: 100%;
  top: 50px;
  left: 0;
  position: absolute;
  -webkit-transition: transform 0.6s ease-in-out;
  -moz-transition: transform 0.6s ease-in-out;
  -o-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
}
.event-details {
  position: absolute;
  display: grid;
  background-color: rgb(32, 34, 47);
  font-size: 1em;
  padding-top: 110px;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
  width: 100%;
  right: 0px;
  /* Transizioni usate per la Sidebar */
  -webkit-transition: transform 0.6s ease-in-out;
  -moz-transition: transform 0.6s ease-in-out;
  -o-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;
}
/* Lista Eventi */
#list {
  position: relative;
  width: 25vw;
  min-width: 345px;
  height: 100%;
  margin-left: 30px;
  overflow: hidden;
}

/* Wrapper Lista Eventi */
section {
  position: sticky;
  top: 0px;
  left: 0;
  height: 100vh;
  margin-top: 30px;
  z-index: 2;
}

/* Wrapper Grafici Disp/FFT */
.inner-event {
  width: 100%;
  min-width: 800px;
}

/* Wrapper Lista Eventi + Grafici Disp/FFT */
.outer-event {
  display: flex;
  width: 96vw;
  min-width: 1100px;
  margin-right: 2vw;
  margin-left: 2vw;
}

/* Più di 1500 */
@media all and (min-width: 1500px) {
  .event-details {
    font-size: 1em;
  }
}
/* Tra 600 e 1499 */
@media all and (max-width: 1799px) and (min-width: 300px) {
  .event-details {
    font-size: 0.82em;
  }
  section {
    height: auto;
  }
}

/* NavBar */
#navbar {
  transition: all 0.3s;
  position: fixed;
  width: 100%;
  min-width: 840px;
  margin-bottom: 50px;
}

/* Loading Transition */
.load-enter,
.load-leave-to {
  opacity: 0;
}
.load-enter-active {
  transition: all 0.3s ease;
}
.load-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

#set {
  z-index: 12;
}

#monitor,
#analog-node {
  z-index: 12;
}
</style>
